import { getTransactionTypeColor, getTransactionTypeTranslationKey } from "@msuite/utils/stock";
import type { Enums } from "@msuite/utils/types";
import { getTransactionTypeIcon, Icon } from "../icons";
import { useTranslation } from "../localization";

/** Props Interface */
interface TransactionTypeTagProps {
	type: Enums<"transactionType">;
}

export function TransactionTypeTag({ type }: TransactionTypeTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="h-stack">
			<Icon
				name={getTransactionTypeIcon(type)}
				color={`var(--color-${getTransactionTypeColor(type)}-500)`}
			/>
			<p>{t(getTransactionTypeTranslationKey(type))}</p>
		</div>
	);
}
